import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  classifWork: null,
  contrNo: null,
  quotNo: null,
  codeNo: null,
  SEQ: null,
  subject: null,
  descr: null,
  startDate: null,
};

export const workRecordSlice = createSlice({
  name: "workRecord",
  initialState,
  reducers: {
    updateWorkRecord: (state, action) => {
      return {
        ...state,
        classifWork: action.payload.classifWork,
        contrNo: action.payload.contrNo,
        quotNo: action.payload.quotNo,
        codeNo: action.payload.codeNo,
        SEQ: action.payload.SEQ,
        subject: action.payload.subject,
        descr: action.payload.descr,
        startDate: action.payload.startDate,
      };
    },
    updateClassifWork: (state, action) => {
      if (action.payload.previousValue) {
        return {
          ...state,
          classifWork: action.payload.classifWork,
          contrNo: null,
          codeNo: null,
          SEQ: null,
          subject: null,
          descr: null,
        };
      } else {
        return {
          ...state,
          classifWork: action.payload.classifWork,
        };
      }
    },
    updateContrNo: (state, action) => {
      if (action.payload.currentDeselectedRowKeys.length > 0) {
        return {
          ...state,
          contrNo: action.payload.contrNo,
          codeNo: null,
          SEQ: null,
          subject: null,
          descr: null,
        };
      } else {
        return {
          ...state,
          contrNo: action.payload.contrNo,
        };
      }
    },
    updateQuotNo: (state, action) => {
      return {
        ...state,
        quotNo: action.payload.quotNo,
      };
    },
    updateCodeNo: (state, action) => {
      if (action.payload.currentDeselectedRowKeys.length > 0) {
        return {
          ...state,
          codeNo: action.payload.codeNo,
          SEQ: null,
          subject: null,
          descr: null,
          quotNo: action.payload.quotNo,
        };
      } else {
        return {
          ...state,
          codeNo: action.payload.codeNo,
          quotNo: action.payload.quotNo,
        };
      }
    },
    updateSEQ: (state, action) => {
      if (action.payload.previousValue) {
        return {
          ...state,
          SEQ: action.payload.SEQ,
          // subject: null,
          subject: action.payload.subject,
          descr: null,
        };
      } else {
        return {
          ...state,
          SEQ: action.payload.SEQ,
          subject: action.payload.subject,
          // descr: action.payload.descr,
          // descr: null,
        };
      }
    },
    updateSubject: (state, action) => {
      return {
        ...state,
        subject: action.payload.subject,
        // descr: null,
      };
    },

    updateDescr: (state, action) => {
      return {
        ...state,
        descr: action.payload.descr,
      };
    },
  },
});

export const {
  updateWorkRecord,
  updateClassifWork,
  updateContrNo,
  updateQuotNo,
  updateCodeNo,
  updateSEQ,
  updateSubject,
  updateDescr,
} = workRecordSlice.actions;

export default workRecordSlice.reducer;
